var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-selector"},[_c('v-btn',[_c('v-icon',[_vm._v("mdi-plus")])],1),_c('v-text-field',{attrs:{"readonly":"","value":_vm.count}}),_c('v-btn',[_c('v-icon',[_vm._v("mdi-minus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }